import { useMe } from '@capsicum/socios-core';
import { useEffect } from 'react';

import { NCOnboardingRoutesEnum, useNCWOnboardingRoutes } from './useNCWOnboardingRoutes';

const NON_PERSISTENT_ROUTES = [
	NCOnboardingRoutesEnum.IDENTITY_VERIFICATION,
	NCOnboardingRoutesEnum.ADDRESS_VERIFICATION
];

/**
 * Hook that redirects user to the main onboarding screen if the current route is a non-persistent one.
 */
export const useResetMainScreen = () => {
	const { currentRoute, goToPage } = useNCWOnboardingRoutes({});
	const { me } = useMe();

	useEffect(() => {
		if (
			(me.metadata?.needsTravelRule && currentRoute !== NCOnboardingRoutesEnum.CONGRATULATIONS) ||
			NON_PERSISTENT_ROUTES.includes(currentRoute as NCOnboardingRoutesEnum)
		) {
			goToPage(NCOnboardingRoutesEnum.CONGRATULATIONS);
		}
	}, []);
};
